import React from 'react'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import { Container, Typography, withStyles } from '@material-ui/core'

import { SignupFormComponent } from '../../../features/signup'
import { signupStyles } from './signup.styles'

export const SignupPage = withStyles(signupStyles)(({ classes }) => {
  const { formatMessage } = useIntl()

  return (
    <div className={classes.root}>
      <div className={classes.leftWrapper}>
        <Container className={classes.container} maxWidth="md">
          <div className={classes.panel}>
            <Typography variant="h4" color="primary" gutterBottom style={{ textAlign: 'center' }}>
              {formatMessage({ id: 'pages.signup.title' })}
            </Typography>
            <SignupFormComponent />
            <div className={classes.loginWrapper}>
              <Typography variant="body2" display="inline" color="textSecondary">
                {formatMessage({ id: 'pages.signup.login.message1' })}
              </Typography>
              <Link to={{ pathname: '/login' }} className={classes.loginLink}>
                <Typography variant="subtitle2" display="inline" className={classes.loginMessage}>
                  {formatMessage({ id: 'pages.signup.login.message2' })}
                </Typography>
              </Link>
            </div>
          </div>
        </Container>
      </div>
    </div>
  )
})
